module.exports = __webpack_public_path__ + "static/media/stamp-on-yellow.35c69a00.webp";